let _store = new Map()

export default class Store {
  static install (Vue, options = {}) {
    // Auto install if it is not done yet and `window` has `Vue`.
    // To allow users to avoid auto-installation in some cases,
    if (!Vue && typeof window !== 'undefined' && window.Vue) {
      install(window.Vue)
    }
  
    // init store
    if (/^\[.*\]$/g.test(sessionStorage.byStore)) {
      _store = new Map(JSON.parse(sessionStorage.byStore))
      sessionStorage.removeItem('byStore')
    }
  
    // watch window refresh
    window.addEventListener('beforeunload', () => {
      sessionStorage.byStore = JSON.stringify([..._store])
    })
  
    // set
    Vue.prototype.$byStoreSet = (key, value) => {
      _store.set(key, value)
    }
  
    // get
    Vue.prototype.$byStoreGet = (key) => {
      return _store.get(key)
    }
  
    // has
    Vue.prototype.$byStoreHas = (key) => {
      return _store.has(key)
    }
    
    // delete
    Vue.prototype.$byStoreDelete = (key) => {
      return _store.delete(key)
    }
    
    // clear
    Vue.prototype.$byStoreClear = () => {
      _store.clear()
    }
  }
}
